<template>
    <div>

        <Card :header="$t('sales')" overlay :loading="requestChart.getLoading()">

            <ErrorMessage :value="requestChart.getError()" />

            <template #nav>
                <div class="d-flex gap-3">
                    <FormSelectTree
                        ref="FormTreeSelect"
                        v-model="categories"
                        :disabled="requestChart.getLoading()"
                        :load-options="fetchCategories"
                        :normalizer="normalizer"
                        :placeholder="$t('category')"
                        multiple
                        class="width-200"
                        show-count-value
                        @change="fetchChart()"
                    />
                </div>
            </template>

            <Chart
                :height="400"
                :series="[]"
                :options="chartOptions"
                :range="groupBy"
            />

        </Card>
    </div>
</template>



<script>
    import { chartDataGroupBy, generateChartData } from '@/utils/chart';
    import Chart from '@/components/common/Chart.vue';
    import FormSelectTree from '@/components/common/FormSelectTree.vue';

    export default {
        name: 'SalesChart',
        components: {
            Chart,
            FormSelectTree,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                requestChart: this.$req('space/SalesChart'),
                requestProductsTree: this.$req('space/ProductsTree'),
                categories: [],
            };
        },
        computed: {
            spaceId() {
                return this.$store.state.space.currentSpaceId;
            },
            timeRange() {
                return this.parentComponent.timeRange;
            },
            apiParams() {
                const urlParams = { spaceId: this.spaceId };
                const requestParams = { ...(this.timeRange || {}), groupBy: this.groupBy };
                if (this.categories?.length) requestParams.categories = this.categories.join(',');
                return { urlParams, requestParams };
            },
            groupBy() {
                return chartDataGroupBy(this.timeRange);
            },
            chartData() {
                return this.requestChart.getData() || [];
            },
            chartOptions() {
                const chartData = this.chartData.reduce(
                    (acc, item) => {
                        acc.amount.push([item.date, item.amount]);
                        acc.quantity.push([item.date, item.quantity]);
                        return acc;
                    },
                    { amount: [], quantity: [] }
                );
                return {
                    series: [
                        {
                            name: this.$t('dashboard.quantity'),
                            type: 'line',
                            data: generateChartData(this.timeRange, chartData.quantity, this.groupBy),
                        },
                        {
                            name: this.$t('dashboard.salesAmount'),
                            type: 'bar',
                            data: generateChartData(this.timeRange, chartData.amount, this.groupBy),
                        },
                    ],
                    yaxis: [
                        {
                            title: {
                                text: this.$t('dashboard.quantity'),
                            },
                        },
                        {
                            opposite: true,
                            title: {
                                text: this.$t('dashboard.salesAmount'),
                            },
                        },
                    ],
                };
            },
        },
        watch: {
            spaceId: {
                handler: 'loadData',
            },
            timeRange: {
                handler: 'loadData',
            },
        },
        methods: {
            loadData() {
                this.fetchChart();
            },
            fetchChart() {
                this.requestChart.get(this.apiParams);
            },
            fetchProductsTree(categoryId) {
                return this.requestProductsTree.get({ urlParams: { spaceId: this.spaceId }, requestParams: { category: categoryId } });
            },
            fetchCategories({ parentNode }) {
                return this.fetchProductsTree(parentNode?.entityId);
            },
            normalizer(node) {
                return {
                    id: node.entityId,
                    label: node.text,
                    children: node.children === true ? null : node.children,
                    isDisabled: node.type === 'product',
                };
            },
        },
        created() {
            this.loadData();
        },
    };
</script>



<style lang="scss" scoped></style>
